module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4GZxk"))).then(() => parcelRequire('iDabs'));